"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var H4 = function H4(_ref) {
  var children = _ref.children,
      larger = _ref.larger,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "larger", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledH4, _extends({
    larger: larger,
    className: className
  }, otherProps), children);
};

var StyledH4 = _styledComponents.default.h4.withConfig({
  displayName: "StyledH4"
})(["font-family:", ";font-weight:500;font-size:", ";line-height:120%;color:", ";> a{color:", ";text-decoration:underline;&:hover{text-decoration:none;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var larger = _ref3.larger;
  return larger ? '1.8rem' : '1.6rem';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.title;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

H4.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  otherProps: _propTypes.object,
  larger: _propTypes.bool
};
var _default = H4;
exports.default = _default;